import { useNavigate } from 'react-router-dom';

import BackButton from '@lib/core/src/components/BackButton';
import { Stack } from '@mui/material';

import RoutesMap from '@/enums/RoutesMap';

import {
  Container,
  Title,
  TitleDescription,
  TitlesContainer,
  TryAgain
} from './ForgotPasswordStyles';

const EmailSent = ({ email, goBack }: { email: string; goBack: () => void }) => {
  const navigate = useNavigate();

  return (
    <Container>
      <TitlesContainer>
        <Title>You've got mail</Title>
        <TitleDescription>
          We sent a reset password email to {email}. Please click the reset password link to set
          your new password.
        </TitleDescription>
      </TitlesContainer>
      <Stack gap="8px">
        <TitleDescription>Haven't received the email?</TitleDescription>
        <Stack gap="4px" direction="row">
          <TitleDescription>Please check your spam folder, or</TitleDescription>
          <TryAgain onClick={() => goBack()}>try again</TryAgain>
        </Stack>
      </Stack>
      <BackButton onClick={() => navigate(RoutesMap.ForgotPassword)} />
    </Container>
  );
};

export default EmailSent;
